import { FC, useEffect, useRef, useState } from 'react';
import { clsx } from 'clsx';

import { DateCard } from '../dateCard';
import { makeRows } from '../lib/utils/makeRows';
import { ITableScheduleProps } from '../models/types';
import {
  HeaderGroupRowTableSchedule,
  HeaderTeacherRowTableSchedule,
} from '../rowTableSchedule';

import styles from './styles.module.scss';

export const TableSchedule: FC<ITableScheduleProps> = ({
  dataDate,
  dataSchedule,
  isGroupSchedule,
}) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const sentinelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!sentinelRef.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsScrolled(!entry.isIntersecting);
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0,
      },
    );

    observer.observe(sentinelRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div className={styles['table-schedule-container']}>
      <DateCard data={dataDate} />
      <div ref={sentinelRef} className={styles['scroll-sentinel']} />
      <div className={styles['table-schedule']}>
        <div
          className={clsx(styles['table-schedule-header'], {
            [styles['table-schedule-header_scrolled']]: isScrolled,
          })}
        >
          {isGroupSchedule ? (
            <HeaderGroupRowTableSchedule isScrolled={isScrolled} />
          ) : (
            <HeaderTeacherRowTableSchedule isScrolled={isScrolled} />
          )}
        </div>
        {makeRows(dataSchedule, isGroupSchedule)}
      </div>
    </div>
  );
};
